import { INaturalTextBehavior } from "./INaturalTextBehavior";

export interface INaturalTextBehaviorSpecifiable {
  naturalTextBehavior: INaturalTextBehavior;
}

export function instanceOfINaturalTextBehaviorSpecifiable(instance: any): instance is INaturalTextBehaviorSpecifiable {
  return instance
    && (instance.naturalTextBehavior !== undefined);
}
